import { render, staticRenderFns } from "./order-history-row.vue?vue&type=template&id=624d9a68&"
import script from "./order-history-row.vue?vue&type=script&lang=js&"
export * from "./order-history-row.vue?vue&type=script&lang=js&"
import style0 from "./order-history-row.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports